import React from "react";
import { useSelector, useDispatch } from "react-redux";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { AddIcon, RemoveIcon } from "../components/icons";
import toPriceDisplay from "../utils/toPriceDisplay";
import { setUser18Older } from "../ducks/shopSlice";
import { selectLayout } from "../ducks/shopSelectors";
import { questionSectionId } from "./QuestionsCards";
import domScrollTo from "../utils/domScrollTo";
import qttDisplay from "../utils/qttDisplay";
import useProductOrder from "../hooks/useProductOrder";
import FloatingProductOrderFooterTotem from "./FloatingProductOrderFooterTotem";

export default function FloatingProductOrderFooter({
  isOrderVisible,
  orderUuid,
  orderUuidEdit,
  // para onde ir depois de adicionar (tela do produto do celular); o totem
  // não passa e continua indo para a home
  returnPath = "/",
}) {
  const dispatch = useDispatch();
  const isTotemPage = useSelector(selectLayout).product === "totem";
  const order = useProductOrder({
    orderUuid,
    orderUuidEdit,
    isOrderVisible,
    returnPath,
  });

  if (!order.ready) {
    return null;
  }

  const dialog18Years = (
    <Dialog18Years
      dispatch={dispatch}
      show18Years={order.show18Years}
      setShow18Years={order.setShow18Years}
      addToCart={order.commitToCart}
    />
  );

  if (isTotemPage) {
    return (
      <>
        <FloatingProductOrderFooterTotem order={order} />
        {dialog18Years}
      </>
    );
  }

  const {
    qtt,
    qttMinimum,
    isKilogram,
    cachedCost,
    increment,
    decrement,
    addToCart,
    disabled,
    buttonLabel,
  } = order;
  const pendingQuestion = order.unansweredRequireds[0];

  // Falta pergunta obrigatória: em vez de abrir um modal com as pendentes, o
  // botão leva o cliente até a primeira delas, que pisca para chamar atenção.
  const handleAddClick = () => {
    if (pendingQuestion) {
      goToQuestion(pendingQuestion.id);
      return;
    }
    addToCart();
  };

  return (
    <footer className="product-footer fixed-bottom">
      <div className="qty-stepper">
        <button
          type="button"
          className="icon-button"
          onClick={decrement}
          disabled={qtt <= qttMinimum}
          aria-label="Diminuir quantidade"
        >
          <RemoveIcon />
        </button>
        <span className="qty-stepper__value" aria-live="polite">
          {qttDisplay(qtt, isKilogram)}
        </span>
        <button
          type="button"
          className="icon-button"
          onClick={increment}
          aria-label="Aumentar quantidade"
        >
          <AddIcon />
        </button>
      </div>
      <button
        type="button"
        className="btn btn-shop product-footer__cta"
        onClick={handleAddClick}
        disabled={disabled}
      >
        {pendingQuestion && !disabled ? (
          <span className="product-footer__label">
            Escolha: {pendingQuestion.description}
          </span>
        ) : (
          <>
            <span className="product-footer__label">{buttonLabel}</span>
            <span>{toPriceDisplay(cachedCost)}</span>
          </>
        )}
      </button>
      {dialog18Years}
    </footer>
  );
}

function goToQuestion(questionId) {
  const section = document.getElementById(questionSectionId(questionId));
  if (!section) return;

  const topBar = document.querySelector(".product-topbar");
  const offset = (topBar ? topBar.offsetHeight : 0) + 8;
  domScrollTo(
    section.getBoundingClientRect().top + window.pageYOffset - offset,
  );

  // reinicia a animação mesmo se o cliente tocar de novo antes de ela acabar
  section.classList.remove("is-attention");
  void section.offsetWidth;
  section.classList.add("is-attention");
  setTimeout(() => section.classList.remove("is-attention"), 1200);
}

function Dialog18Years({ dispatch, show18Years, setShow18Years, addToCart }) {
  const [under18Years, setUnder18Years] = React.useState(null);
  const handleClose = () => {
    setShow18Years(false);
    setUnder18Years(null);
  };

  const handleNo = () => setUnder18Years(true);

  const handleYes = (e) => {
    dispatch(setUser18Older({ user18Older: true }));
    handleClose();
    addToCart(e);
  };

  return (
    <Modal show={show18Years} onHide={handleClose}>
      <Modal.Body>
        {under18Years === null && (
          <div className="p-3">
            <h1 className="py-3 text-center">Você tem 18 anos ou mais?</h1>
            <div className="py-3 w-100 d-inline-flex flex-grow-1 justify-content-between">
              <Button
                className="w-50 me-2"
                variant="outline-shop"
                onClick={handleNo}
              >
                NÃO
              </Button>
              <Button
                className="w-50 ms-2"
                variant="shop"
                type="submit"
                onClick={handleYes}
              >
                SIM
              </Button>
            </div>
          </div>
        )}
        {under18Years === true && (
          <div className="p-3">
            <h1 className="py-3 text-center">
              Você precisa ter 18 anos ou mais para consumir bebidas alcoólicas.
            </h1>
            <h1 className="py-3 text-center">Relaxe, o tempo passa rápido!</h1>
            <div className="py-3 w-100 d-inline-flex flex-grow-1 justify-content-center">
              <Button
                className="w-50"
                variant="shop"
                type="submit"
                onClick={handleClose}
              >
                VOLTAR
              </Button>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}
